module.exports = __webpack_public_path__ + "static/media/k-ilustracion.32823712.png";